export default __webpack_public_path__ + "static/media/Q20_1_resized.00aa1633.jpg";